import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { OnboardingAxios } from "../../API";
import authSlice from "../../store/auth/authSlice";
import Moment from "react-moment";
import Avatar from "../commonComponents/Avatar";

const MissionDirectorProfile = (props) => {

  const [userProfileMetaData, setUserProfileMetaData] = useState(null);

  useEffect(() => {
    OnboardingAxios.get(
      "UserProfile/getuserprofile/" +
      props.userProfile.id +
      "/" +
      props.offeringId
    )
      .then(function (response) {
        setUserProfileMetaData(response.data.userProfileMetaData);
      })
      .catch(function (error) {
        console.log("error: " + error);
      });
  }, []);


  return (
    <>
      <Modal
        show={true}
        backdrop="static"
        fullscreen={true}
        onHide={() => {
          props.hideProfile();
        }}
        keyboard={false}
        className="profile-modal"
      >
        <Modal.Header>
          <div className="branding">
            <div className="logo-image"> </div>
            <div className="logo-text"></div>
            <div className="branding-glow"></div>
          </div>
          <div
            className="modal-close-btn"
            onClick={() => {
              props.hideProfile();
            }}
          ></div>
        </Modal.Header>
        <Modal.Body>
          {(
            <div>
              {props && (
                <Row>
                  <Col md={3} className="">
                    <div className="profile-left-div">
                      <div className={props.userProfile.roleId == 5 ? "profile-img-outline coach" : "profile-img-outline"}>
                        <div className="profile-frame-border">
                          <div className="profile-frame">
                            {props.userProfile.profileImage &&
                              props.userProfile.profileImage !== "NA" &&
                              <img className="profile-img" src={props.userProfile.profileImage} alt="" />
                            }
                            {(!props.userProfile.profileImage ||
                              props.userProfile.profileImage === "NA") && (
                                <div className="profile-text">
                                  <span>
                                    {props.userProfile.firstName[0].toUpperCase() +
                                      "" +
                                      props.userProfile.lastName[0].toUpperCase()}
                                  </span>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>

                      <div className="profile-user-name mb-2">
                        {props.userProfile.firstName}{" "}
                        {props.userProfile.lastName}
                      </div>
                      <div className="profile-initial-details">
                        <div className="industry">
                          <span></span>
                          <span>{props.userProfile.industry}</span>
                        </div>
                        <div className="cbo">
                          <span></span>

                          <span>{props.userProfile.jobLevel}</span>
                        </div>
                        <div className="email">
                          <span></span>
                          <span>{props.userProfile.email}</span>
                        </div>
                        <div className="location">
                          <span></span>
                          <span>{props.userProfile.location}</span>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={8} className="">
                    <div className="profile-about-me">
                      <div className="profile-header profile-border-bottom">
                        <span>About me</span>
                      </div>
                      <div className="profile-details-body">
                        {userProfileMetaData &&
                          userProfileMetaData.length > 0 &&
                          userProfileMetaData
                            .filter((x) => x.category == "About me")
                            .map((item, index) => {
                              return (
                                <Row className="mt-3" key={"r" + index}>
                                  <Col md={1} style={{ width: "40px" }}>
                                    <span className="bullets"></span>
                                  </Col>
                                  <Col md={5}>
                                    <span className="bulletLabel">
                                      {item.value}
                                    </span>
                                  </Col>
                                  <Col md={6}>
                                    <div className="profile-desc">
                                      <span className="pe-2">:</span>
                                      {item.answer
                                        ? item.answer.replace(/,/g, ", ")
                                        : ""}
                                    </div>
                                  </Col>
                                </Row>
                              );
                            })}
                      </div>
                    </div>
                    <div className="profile-communities-of-interest">
                      <div className="profile-header profile-border-bottom">
                        <span>Communities of Interest</span>
                      </div>
                      <div className="profile-details-body">
                        {userProfileMetaData &&
                          userProfileMetaData.length > 0 &&
                          userProfileMetaData
                            .filter(
                              (x) => x.category == "Communities of Interest"
                            )
                            .map((item, index) => {
                              return (
                                <Row className="mt-3" key={"r1" + index}>
                                  <Col md={1} style={{ width: "40px" }}>
                                    <span className="bullets"></span>
                                  </Col>
                                  <Col md={5}>
                                    <span className="bulletLabel">
                                      {item.value}
                                    </span>
                                  </Col>
                                  <Col md={6}>
                                    <div className="profile-desc">
                                      <span className="pe-2">:</span>
                                      {item.answer
                                        ? item.answer.replace(/,/g, ", ")
                                        : ""}
                                    </div>
                                  </Col>
                                </Row>
                              );
                            })}
                      </div>
                    </div>

                  </Col>

                </Row>
              )}
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MissionDirectorProfile;
